<template>
    <AppModal :name="name" :beforeOpen="beforeOpen" :beforeClose="beforeClose">
        <template slot="header">
            {{ title }}
        </template>
        <template slot="content">
            <h6 v-if="subtitle">
                {{ subtitle }}
            </h6>
            <p v-if="description" class="text-semi-bold">
                {{ description }}
            </p>
        </template>
        <template slot="actions">
            <button v-if="isTrialEnded"
                    @click="toBillingPage"
                    class="btn btn-sm btn-primary">
                Add Credit Card
            </button>
            <button v-if="isFailedPayment"
                    @click="toBillingPage"
                    class="btn btn-sm btn-primary">
                Update Credit Card
            </button>
            <button v-else-if="isExpiredCard"
                    @click="editCard"
                    class="btn btn-sm btn-primary">
                Add Credit Card
            </button>
            <!--            <button v-else-if="isPlanQuotaExceeded"-->
            <!--                    @click="upgradePlan"-->
            <!--                    class="btn btn-sm btn-primary">-->
            <!--                Upgrade plan-->
            <!--            </button>-->
            <br>
            <button @click="onReject" class="btn btn-sm btn-link mt-3">
                Cancel
            </button>
        </template>
    </AppModal>
</template>

<script>
import {mapGetters} from 'vuex'
import {SETTINGS_BILLING} from '../../views/settings/settings-tabs'

export default {
    name: 'UpdateBillingAlert',
    props: {
        name: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            title: null,
            subtitle: null,
            description: null,

            resolve: null,
            reject: null
        }
    },
    computed: {
        ...mapGetters('billing', [
            'billingInfo',
            'isTrialEnded',
            'isExpiredCard',
            'isFailedPayment',
            'isPlanQuotaExceeded'
        ])
    },
    methods: {
        beforeOpen({params}) {
            this.resolve = params.resolve
            this.reject = params.reject

            if (this.isTrialEnded) {
                this.title = 'Your trial has expired'
                this.description = 'To continue processing invoices please update your billing details'
            } else if (this.isExpiredCard) {
                this.title = 'Your credit card has expired'
                this.description = 'Update your billing details to continue'
            } else if (this.isPlanQuotaExceeded) {
                this.title = 'You exceeded your plan quota for this month'
                if (this.billingInfo.allowance &&
                    this.billingInfo.allowance.invoices &&
                    this.billingInfo.usage &&
                    this.billingInfo.usage.invoices) {
                    this.subtitle = `${this.billingInfo.usage.invoices} / ${this.billingInfo.allowance.invoices} invoices`
                }
                this.description = 'Do you want to upgrade your plan to continue?'
            } else if (this.isFailedPayment) {
                this.title = 'Billing error'
                this.description = 'Update your billing details to continue'
            } else { // unknown case (?)
                this.title = 'Billing error'
                this.description = 'Update your billing details to continue'
            }
        },

        beforeClose() {
            this.resolve = null
            this.reject = null
        },

        editCard() {
            this.closeModal()
            this.$modal.show('edit-billing-card')
        },

        upgradePlan() {
            this.closeModal()
            this.$modal.show('change-billing-plan')
        },

        toBillingPage() {
            this.closeModal()
            this.$router.push({name: 'settings', params: {page: SETTINGS_BILLING}})
        },

        async onReject() {
            this.closeModal()
            if (typeof this.reject === 'function') {
                this.reject()
            }
        },

        async onResolve() {
            this.closeModal()
            if (typeof this.resolve === 'function') {
                this.resolve()
            }
        },

        closeModal() {
            this.$modal.hide(this.name)
        }
    }
}
</script>

<style scoped>
</style>
